export const WALLET_INDICATOR_PT_BR = {
	wallet: "Carteira",
	totalBalance: "Saldo Total",
	withdrawal: "Disponível para saque",
	anticipation: "Disponível para antecipação",
	anticipationSmDevice: "Disponível para antecipação",
	anticipationTooltip:
		"Valores de transações de cartão de crédito que ainda não foram liquidadas.",
	seeWallet: "Ver Carteira",
	yourAccounts: "Suas contas",
	blockedBalance: "Valor Bloqueado",
	blockedBalanceTooltip:
		"Valores retidos pela Zig por motivos operacionais, lançamentos futuros, repasses ao Vendor e demais bloqueios.",
	blockedByPendingWithdraws: "Saques em processamento",
	blockedByPendingWithdrawsTooltip:
		"O valor total corresponde aos pedidos de saque em processamento pela Zig",
};

export type WalletIndicatorTranslations = typeof WALLET_INDICATOR_PT_BR;
